import React from "react";

import { Layout } from "antd";

import { Outlet } from "react-router-dom";
import SiderMenu from "./SiderMenu";

const { Header, Sider, Content } = Layout;

const VerticalLayout = () => {
  return (
    <Layout style={{ height: "100vh" }} className="v-layout">
      <Sider trigger={null}>
        <SiderMenu />
      </Sider>
      <Layout>
        <Header>
          <div className="layout_header">
            {/* <h3>Dashboard</h3> */}
            <div className="user_detail">
              <div className="name_box">
                {/* <h4>John Doe</h4> */}
                <p>Admin</p>
              </div>
              <div className="users_image_box">
                <img
                  src={require("../../assets/images/user-icon.jpg")}
                  alt="Icon"
                />
              </div>
            </div>
          </div>
        </Header>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default VerticalLayout;
